import { Component, inject, OnInit } from '@angular/core';
import { BrandingService, CrmPlatformApiService, PROFILE_ACTION_BUTTON_DATA_TOKEN } from '@galaxy/crm/static';
import { BusinessCenterService, VBCEntryInfo } from '../../../core/business-center.service';
import { AccessBusinessAppService } from '../../profile-cards/association-cards/access-business-app/access-business-app.service';

import { AsyncPipe, NgComponentOutlet, NgForOf, NgIf } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-business-app-button',
  template: `
    <a
      *ngIf="businessAppButton$ | async as appDetails"
      [href]="appDetails.url"
      mat-stroked-button
      target="_blank"
      rel="noopener"
    >
      {{ this.translateService.instant('COMPANY.LIST_OBJECTS_TABLE.ACTIONS.OPEN_BUSINESS_APP') }} {{ appDetails.name }}
      <mat-icon iconPositionEnd>open_in_new</mat-icon>
    </a>
  `,
  standalone: true,
  providers: [AccessBusinessAppService, BrandingService, CrmPlatformApiService, TranslateService],

  imports: [MatIconModule, MatButtonModule, NgComponentOutlet, NgIf, NgForOf, MatExpansionModule, AsyncPipe],
})
export class ActionButtonComponent implements OnInit {
  businessAppButton$: Observable<VBCEntryInfo> | undefined;
  data = inject(PROFILE_ACTION_BUTTON_DATA_TOKEN);
  businessCenterService = inject(BusinessCenterService);
  translateService = inject(TranslateService);

  ngOnInit(): void {
    this.businessAppButton$ = this.businessCenterService.getVBCEntryUrl(this.data.account_group_id);
  }
}
